import styled from 'styled-components';
import { getColor } from '../../../styling/mixins/colors';
import { breakpoint } from '../../../styling/mixins/breakpoints';
import { text } from '../../../styling/mixins/typography';
import SideMenu from '../../SideMenu/SideMenu';

export const StyledSizeGuideContainer = styled.div`
  .section {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
`;
export const StyledSizeGuideTrigger = styled.button`
  text-decoration: underline;
  ${text('small')};
  ${getColor('black')};
`;

export const StyledSizeGuideMenu = styled(SideMenu)`
  overflow-y: auto;
  ${breakpoint('large')} {
    width: 840px !important;
    max-width: 840px !important;
  }
  .side-menu-content {
    background-color: ${getColor('gray', 100)};
    padding-top: 2.4rem;
    padding-left: 2.4rem;
    padding-right: 2.4rem;
    flex: 1;
    table {
      overflow-x: auto;
      display: block;
      tbody {
        border-radius: 0.4rem;
        border-top: 1px solid ${getColor('gray', 300)};
        td {
          border-bottom: 1px solid ${getColor('gray', 300)};
          border-right: 1px solid ${getColor('gray', 300)};
          padding: 0.8rem;
          min-width: 100px;
        }
        tr {
          border-left: 1px solid ${getColor('gray', 300)};
          &:nth-of-type(odd) {
            background-color: white;
          }
        }
      }
    }
  }
`;
